import React from 'react';
import { ServersLocations } from 'components';

const V1 = [
    {
        label: {
            en: 'General',
            es: 'General',
            ru: 'Общий',
            fa: 'عمومی',
        },
        urls: [
            'stratum+tcp://stratum.braiins.com:3333',
            //
        ],
    },
    {
        label: {
            en: 'Europe',
            es: 'Europa',
            ru: 'Европа',
            fa: 'اروپا',
        },
        urls: [
            'stratum+tcp://eu.stratum.braiins.com:3333',
            //
        ],
    },
    {
        label: {
            en: 'USA',
            es: 'EE. UU.',
            ru: 'США',
            fa: 'ایالات متحده',
        },
        where: {
            en: 'East Coast',
            es: 'Costa Este',
            ru: 'Восточное побережье',
            fa: 'ساحل شرقی',
        },
        urls: [
            'stratum+tcp://us-east.stratum.braiins.com:3333',
            //
        ],
    },
    {
        label: {
            en: 'Brazil',
            es: 'Brasil',
            ru: 'Бразилия',
            fa: 'برزیل',
        },
        where: {
            en: 'South America',
            es: 'América del Sur',
            ru: 'Южная Америка',
            fa: 'آمریکای جنوبی',
        },
        urls: [
            'stratum+tcp://br.stratum.braiins.com:3333',
            //
        ],
    },
    {
        label: {
            en: 'Canada',
            es: 'Canadá',
            ru: 'Канада',
            fa: 'کانادا',
        },
        urls: [
            'stratum+tcp://ca.stratum.braiins.com:3333',
            //
        ],
    },
    {
        label: {
            en: 'Singapore',
            es: 'Singapur',
            ru: 'Сингапур',
            fa: 'سنگاپور',
        },
        where: {
            en: 'South Asia',
            es: 'Asia del Sur',
            ru: 'Южная Азия',
            fa: 'جنوب آسیا',
        },
        urls: [
            'stratum+tcp://sg.stratum.braiins.com:3333',
            //
        ],
    },
    {
        label: {
            en: 'Russia',
            es: 'Rusia',
            ru: 'Россия',
            fa: 'روسیه',
        },
        where: {
            en: 'Moscow',
            es: 'Moscú',
            ru: 'Москва',
            fa: 'مسکو',
        },
        urls: [
            'stratum+tcp://ru-west.stratum.braiins.com:3333',
            //
        ],
    },
];
const V2 = [
    {
        label: {
            en: 'General',
            es: 'General',
            ru: 'Общий',
            fa: 'عمومی',
        },
        urls: [
            'stratum2+tcp://v2.stratum.braiins.com/u95GEReVMjK6k5YqiSFNqqTnKU4ypU2Wm8awa6tmbmDmk1bWt',
            //
        ],
    },
    {
        label: {
            en: 'Europe',
            es: 'Europa',
            ru: 'Европа',
            fa: 'اروپا',
        },
        urls: [
            'stratum2+tcp://v2.eu.stratum.braiins.com/u95GEReVMjK6k5YqiSFNqqTnKU4ypU2Wm8awa6tmbmDmk1bWt',
            //
        ],
    },
    {
        label: {
            en: 'USA',
            es: 'EE. UU.',
            ru: 'США',
            fa: 'ایالات متحده',
        },
        where: {
            en: 'East Coast',
            es: 'Costa Este',
            ru: 'Восточное побережье',
            fa: 'ساحل شرقی',
        },
        urls: [
            'stratum2+tcp://v2.us-east.stratum.braiins.com/u95GEReVMjK6k5YqiSFNqqTnKU4ypU2Wm8awa6tmbmDmk1bWt',
            //
        ],
    },
    {
        label: {
            en: 'Brazil',
            es: 'Brasil',
            ru: 'Бразилия',
            fa: 'برزیل',
        },
        where: {
            en: 'South America',
            es: 'América del Sur',
            ru: 'Южная Америка',
            fa: 'آمریکای جنوبی',
        },
        urls: [
            'stratum2+tcp://v2.br.stratum.braiins.com/u95GEReVMjK6k5YqiSFNqqTnKU4ypU2Wm8awa6tmbmDmk1bWt',
            //
        ],
    },
    {
        label: {
            en: 'Canada',
            es: 'Canadá',
            ru: 'Канада',
            fa: 'کانادا',
        },
        urls: ['stratum2+tcp://v2.ca.stratum.braiins.com/u95GEReVMjK6k5YqiSFNqqTnKU4ypU2Wm8awa6tmbmDmk1bWt'],
    },
    {
        label: {
            en: 'Singapore',
            es: 'Singapur',
            ru: 'Сингапур',
            fa: 'سنگاپور',
        },
        where: {
            en: 'South Asia',
            es: 'Asia del Sur',
            ru: 'Южная Азия',
            fa: 'جنوب آسیا',
        },
        urls: [
            'stratum2+tcp://v2.sg.stratum.braiins.com/u95GEReVMjK6k5YqiSFNqqTnKU4ypU2Wm8awa6tmbmDmk1bWt',
            //
        ],
    },
    {
        label: {
            en: 'Russia',
            es: 'Rusia',
            ru: 'Россия',
            fa: 'روسیه',
        },
        where: {
            en: 'Moscow',
            es: 'Moscú',
            ru: 'Москва',
            fa: 'مسکو',
        },
        urls: [
            'stratum2+tcp://v2.ru-west.stratum.braiins.com/u95GEReVMjK6k5YqiSFNqqTnKU4ypU2Wm8awa6tmbmDmk1bWt',
            //
        ],
    },
];

const SOLO = [
    {
        label: {
            en: 'URL1',
            es: 'URL1',
            ru: 'URL1',
            fa: 'URL1',
        },
        urls: [
            'stratum+tcp://solo.stratum.braiins.com:3333',
            //
        ],
    },
    {
        label: {
            en: 'URL2',
            es: 'URL2',
            ru: 'URL2',
            fa: 'URL2',
        },
        urls: [
            'stratum+tcp://solo.stratum.braiins.com:443',
            //
        ],
    },
    {
        label: {
            en: 'URL3',
            es: 'URL3',
            ru: 'URL3',
            fa: 'URL3',
        },
        urls: [
            'stratum+tcp://solo.stratum.braiins.com:25',
            //
        ],
    },
];

export function BitcoinMiningUrlsV1() {
    return <ServersLocations data={V1} />;
}

export function BitcoinMiningUrlsV2() {
    return <ServersLocations data={V2} />;
}

export function BitcoinMiningUrlsSOLO() {
    return <ServersLocations data={SOLO} />;
}
